import { cn } from "~/foundation/utils/cn";

export interface SpinnerProps {
  size?: number;
  label?: string;
  className?: string;
}

export function Spinner({ size = 16, label, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      aria-live="polite"
      className={cn("inline-block animate-spin motion-reduce:animate-none", className)}
      style={{
        width: size,
        height: size,
        border: "2px solid var(--input-border)",
        borderTopColor: "var(--accent)",
        borderRadius: "50%",
      }}
    />
  );
}
